import React from 'react';
import { TrendingUp, Sparkles, Calendar, MessageCircle, Shield, Star } from 'lucide-react';

export const ProductShowcase = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center space-y-4">
        <h1 className="text-3xl sm:text-4xl font-bold text-white leading-tight">
          AI-Powered Market Insights for Smarter Decisions
        </h1>
        <p className="text-blue-100/80 text-sm max-w-md mx-auto">
          Join 10,000+ investors using Strykr.ai to gain an edge in today's volatile markets.
        </p>
      </div>

      {/* Market Overview Chart */}
      <div className="bg-gray-900/60 border border-gray-700/50 rounded-lg p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4 text-blue-400" />
            <span className="text-sm font-medium text-gray-300">Market Overview</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs text-emerald-400 font-medium">Live Data</span>
            <div className="h-2 w-2 rounded-full bg-emerald-500 animate-pulse"></div>
          </div>
        </div>
        
        {/* Chart */}
        <div className="relative h-24">
          <svg className="w-full h-full" viewBox="0 0 400 80" preserveAspectRatio="none">
            <path 
              d="M0,60 C50,55 100,50 150,45 C200,40 250,35 300,30 C350,25 400,20 400,20" 
              fill="none" 
              stroke="rgba(59,130,246,0.8)" 
              strokeWidth="2"
              strokeDasharray="400"
              strokeDashoffset="400"
              className="animate-dash"
            />
          </svg>
          
          {/* Data Points */}
          <div className="absolute top-1/3 left-1/4">
            <div className="h-2 w-2 rounded-full bg-blue-500 animate-pulse"></div>
          </div>
          <div className="absolute top-1/4 right-1/3">
            <div className="h-2 w-2 rounded-full bg-blue-400 animate-pulse"></div>
          </div>
        </div>
      </div>

      {/* What you'll get section */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-white text-center">What you'll get:</h3>
        
        <div className="grid grid-cols-2 gap-3">
          {/* AI-Powered Insights */}
          <div className="bg-gray-900/40 border border-gray-700/30 rounded-lg p-3 text-center">
            <Sparkles className="h-5 w-5 text-blue-400 mx-auto mb-2" />
            <h4 className="text-sm font-medium text-white mb-1">AI-Powered Insights</h4>
            <p className="text-xs text-gray-400">Get personalized market analysis and recommendations</p>
          </div>

          {/* Real-Time Market Data */}
          <div className="bg-gray-900/40 border border-gray-700/30 rounded-lg p-3 text-center">
            <TrendingUp className="h-5 w-5 text-emerald-400 mx-auto mb-2" />
            <h4 className="text-sm font-medium text-white mb-1">Real-Time Market Data</h4>
            <p className="text-xs text-gray-400">Stay informed with real-time updates and alerts</p>
          </div>

          {/* Economic Calendar */}
          <div className="bg-gray-900/40 border border-gray-700/30 rounded-lg p-3 text-center">
            <Calendar className="h-5 w-5 text-yellow-400 mx-auto mb-2" />
            <h4 className="text-sm font-medium text-white mb-1">Economic Calendar</h4>
            <p className="text-xs text-gray-400">Track key economic events and their market impact</p>
          </div>

          {/* Financial AI Chat */}
          <div className="bg-gray-900/40 border border-gray-700/30 rounded-lg p-3 text-center">
            <MessageCircle className="h-5 w-5 text-purple-400 mx-auto mb-2" />
            <h4 className="text-sm font-medium text-white mb-1">Financial AI Chat</h4>
            <p className="text-xs text-gray-400">Ask questions and get instant financial answers</p>
          </div>
        </div>
      </div>

      {/* Trust indicators */}
      <div className="space-y-3 pt-2">
        <div className="flex items-center justify-center gap-2 text-xs text-gray-400">
          <Shield className="h-3 w-3 text-blue-400" />
          <span>Secure, bank-level encryption</span>
        </div>
        
        <div className="flex items-center justify-center gap-2 text-xs text-gray-400">
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-3 w-3 fill-yellow-400 text-yellow-400" />
            ))}
          </div>
          <span>Trusted by financial professionals</span>
        </div>
      </div>
    </div>
  );
};

export default ProductShowcase;
